import { Component, OnDestroy, OnInit } from '@angular/core'
import { NavigationEnd, NavigationStart, Router } from '@angular/router'
import { FuseConfigService } from '../../core/services/config.service'
import { TranslateService } from '@ngx-translate/core'
import { AuthService } from '../../auth.service'
import { ProfileModel } from '../models/profile.model'
import { ProfileService } from '../services/profile.service'
import { Subscription } from 'rxjs/Subscription'
import { ResourceLoadingService } from '../services/resource-loading.service'

@Component({
  selector: 'fuse-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
})
export class FuseToolbarComponent implements OnInit, OnDestroy {
  userStatusOptions: any[]
  languages: any
  selectedLanguage: any
  showLoadingBar = false
  horizontalNav: boolean
  profile: ProfileModel
  onLogin: Subscription
  isLoading: Subscription

  constructor(
    private router: Router,
    private fuseConfig: FuseConfigService,
    private translate: TranslateService,
    private authService: AuthService,
    private profileService: ProfileService,
    private _loadingService: ResourceLoadingService,
  ) {
    this.profile = new ProfileModel({})

    this.languages = [
      {
        id: 'en',
        title: 'English',
        flag: 'us',
      },
      {
        id: 'nl',
        title: 'Nederlands',
        flag: 'tr',
      },
    ]

    this.selectedLanguage = this.languages[0]

    router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.showLoadingBar = true
      }
      if (event instanceof NavigationEnd) {
        this.showLoadingBar = false
      }
    })

    this.fuseConfig.onSettingsChanged.subscribe(settings => {
      this.horizontalNav = settings.layout.navigation === 'top'
    })
  }

  ngOnInit() {
    this.isLoading = this._loadingService.isLoading.subscribe(loading => {
      this.showLoadingBar = loading
    })

    this.onLogin = this.profileService.onProfileChanged.subscribe(profile => {
      this.profile = profile
    })
  }

  onLogout() {
    this.authService.logout()
  }

  ngOnDestroy() {
    this.onLogin.unsubscribe()
    // this.isLoading.unsubscribe();
  }

  search(value) {
    // Do your search here...
    console.log(value)
  }

  setLanguage(lang) {
    // Set the selected language for toolbar
    this.selectedLanguage = lang

    // Use the selected language for translations
    this.translate.use('nl')
  }
}



// WEBPACK FOOTER //
// ./src/app/main/toolbar/toolbar.component.ts